module.exports = __webpack_public_path__ + "img/superkid-logo2.b1d68865.svg";